import type { PropsWithChildren } from "react";
import React from "react";

import { ReactQueryProvider } from "./ReactQueryProvider";
import { sentryConfig } from "./sentry/sentry";
import { SentryProvider } from "./sentry/SentryProvider";

export const Providers = ({ children }: PropsWithChildren) => {
  sentryConfig();

  return (
    <ReactQueryProvider>
      <SentryProvider>{children}</SentryProvider>
    </ReactQueryProvider>
  );
};
